import { replace } from 'ramda';

export const addInlineStyles = (tagWithoutStyle: string, align: string) =>
  tagWithoutStyle
    ? //nosemgrep: javascript.lang.security.audit.incomplete-sanitization.incomplete-sanitization
      replace('>', ` style="text-align: ${align}">`, tagWithoutStyle)
    : '';
